"use client";

import React, { createContext, useContext, useState, ReactNode } from 'react';

export type TalkingAnimationType = 'Talking_0' | 'Talking_1' | 'Talking_2';

export type AnimationType = TalkingAnimationType | 'Crying' | 'Laughing' | 'Rumba' | 'Idle' | 'Terrified' | 'Angry' | 'Thinking';

export type EmotionType = 'smile' | 'sad' | 'angry' | 'surprised' | 'funnyFace' | 'default';

interface AvatarState {
  currentAnimation: AnimationType;
  currentEmotion: EmotionType;
  setAnimation: (animation: AnimationType) => void;
  setEmotion: (emotion: EmotionType) => void;
}

const AvatarContext = createContext<AvatarState | undefined>(undefined);

export const useAvatar = () => {
  const context = useContext(AvatarContext);
  if (!context) {
    throw new Error('useAvatar must be used within an AvatarProvider');
  }
  return context;
};

interface AvatarProviderProps {
  children: ReactNode;
}

export const AvatarProvider: React.FC<AvatarProviderProps> = ({ children }) => {
  const [currentAnimation, setCurrentAnimation] = useState<AnimationType>('Idle');
  const [currentEmotion, setCurrentEmotion] = useState<EmotionType>('default');

  const value: AvatarState = {
    currentAnimation,
    currentEmotion,
    setAnimation: setCurrentAnimation,
    setEmotion: setCurrentEmotion,
  };

  return (
    <AvatarContext.Provider value={value}>
      {children}
    </AvatarContext.Provider>
  );
};
